import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer,createMigrate } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import storage from './storageFallback'; // ✅ use your fallback wrapper
import Login from '../auth/authReducer'; // Import your auth reducer
import Layout from '../layout/reducers';
import PageTitle from '../pageTitle/reducers';
import maiActionsReducer from '../maiAction/maiActionReducer'
import contactReducer from '../contacts/contactReducer';
import debugLogsReducer from '../DebugLogs/debugLogsReducer';
// import actionsReducer from '../reducers/actionsReducer'; // Import your actions reducer

// 🔥 Force persist after successful login
const migrations = {
    1: (state) => {
        // This will be called if the current version is > version in localStorage
        console.log("Running migration v1: resetting Auth");
        return {
            ...state,
            Auth: undefined, // or INIT_STATE if you want
        };
    },
};
const persistConfig = {
    key: 'root',
    version: 3,
    storage,
    // whitelist: ['Auth'],
    blacklist: ['Action', 'Contact', 'DebugLogs', 'Layout' ] ,  //['Action','Auth','Contact'], // Don't persist the actions reducer 
    migrate: createMigrate(migrations, { debug: true }),
};

const rootReducer = combineReducers({
    Auth: Login,
    Layout: Layout,
    PageTitle: PageTitle,
    Action: maiActionsReducer,
    Contact: contactReducer,
    DebugLogs: debugLogsReducer,
    // actions: actionsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
